/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { PermitDetails } from "./permit-details";
import { PermitList } from "./permit-list";
import { useFetchPermit } from "cms/hooks/use-fetch-permit";
import { AuthCustomerGuard } from "cms/auth-customer/auth-customer-guard";
import { NotAuthCustomerGuard } from "cms/auth-customer/notauth-customer-guard";
import { PleaseLogin } from "./please-login";
import { FilterSearch } from "./filter-search";
// import { YourSearch } from "./private-search";

const MyPermitDisplayComponent = (props) => {
    const component = props?.component ?? {};
    const {
        isMyPermitLoading,
        myPermits,
        // fetchPrePermitQuery,
        // fetchPermitByQuery
    } = useFetchPermit();

    const [selectedPermit, setSelectedPermit] = useState(null);
    // const [rawQueryValue, setRawQueryValue] = useState("");

    const [permits, setPermits] = useState(myPermits);

    const [, setQueryValue] = useState();
    const [searchText, setSearchText] = useState("");

    // const [queryType, setQueryType] = useState();

    // const buildPermitQuery = async (value) => {
    //     setRawQueryValue(value);
    //     const { data, type } = await fetchPrePermitQuery({ value });
    //     setQueryType(type);
    //     return data || [];
    // };

    // const privateSearchHandler = async () => {
    //     // Fetch Permits by query
    //     const payload = {
    //         type: queryType,
    //         value: queryValue || rawQueryValue,
    //     };
    //     await fetchPermitByQuery(payload);
    // };

    const onSelectOption = (data) => {
        setQueryValue(data);
    };

    const resetFetch = async () => {
        // Fetch my permit
        console.log("fetching");
    };

    const _onChangeHandler = (event) => {
        const value = event.target.value;
        setSearchText(value);
    };

    const _onSearchHandler = () => {
        const _searchText = searchText.toLocaleLowerCase();
        if (searchText) {
            const _permits = permits.filter((permit) => {
                return permit.permit_number.toLowerCase().includes(_searchText) || permit.main_address.toLowerCase().includes(_searchText);
            });
            setPermits(_permits);
        } else {
            setPermits(myPermits);
        }
    };

    useEffect(() => {
        setPermits(myPermits);
    }, [myPermits]);

    return (
        <>
            <AuthCustomerGuard>
                {/*<AuthenticatedTemplate>*/}
                <div className="permit-display-container">
                    {!!selectedPermit && (
                        <PermitDetails permit={selectedPermit} setSelectedPermit={setSelectedPermit} />
                    )}
                    {!selectedPermit && (
                        <PermitList
                            component={component}
                            isLoading={isMyPermitLoading}
                            permits={permits}
                            setSelectedPermit={setSelectedPermit}
                            // onChangeHandler={buildPermitQuery}
                            // onSearchHandler={privateSearchHandler}
                            onChangeHandler={_onChangeHandler}
                            onSearchHandler={_onSearchHandler}
                            searchText={searchText}
                            onSelectOption={onSelectOption}
                            resetFetch={resetFetch}
                            SearchFilterComp={FilterSearch}
                        />
                    )}
                </div>
                {/*</AuthenticatedTemplate>*/}
            </AuthCustomerGuard>
            <NotAuthCustomerGuard>
                <PleaseLogin />
            </NotAuthCustomerGuard>
        </>
    );
};

MyPermitDisplayComponent.displayName = "MyPermitDisplayComponent";
export { MyPermitDisplayComponent };
